/* Lids by Design — landing interactions.
   Loaded by multiple sections; guarded so it initializes only once. */
(function () {
  if (window.__lbdLandingInit) return;
  window.__lbdLandingInit = true;

  function init() {
    /* ---- Before / After slider(s) ---- */
    document.querySelectorAll('.crxlbd-ba').forEach(function (ba) {
      if (ba.__lbdBound) return;
      ba.__lbdBound = true;
      var dragging = false;
      var pos = parseFloat(ba.getAttribute('aria-valuenow')) || 50;
      function setPos(pct) {
        pct = Math.max(0, Math.min(100, pct));
        pos = pct;
        ba.style.setProperty('--crx-pos', pct + '%');
        ba.setAttribute('aria-valuenow', Math.round(pct));
      }
      function fromEvent(e) {
        var rect = ba.getBoundingClientRect();
        var x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
        setPos((x / rect.width) * 100);
      }
      var startX = 0, startY = 0, decided = false, capturedId = null;
      ba.addEventListener('pointerdown', function (e) {
        dragging = true; decided = false; capturedId = e.pointerId;
        startX = e.clientX; startY = e.clientY;
        // For mouse/pen, drag immediately; for touch, wait to see the direction.
        if (e.pointerType !== 'touch') { decided = true; try { ba.setPointerCapture(e.pointerId); } catch (err) {} fromEvent(e); }
      });
      ba.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        if (!decided) {
          var dx = Math.abs(e.clientX - startX);
          var dy = Math.abs(e.clientY - startY);
          if (dx < 6 && dy < 6) return;           // too small to tell yet
          if (dy > dx) { dragging = false; return; } // mostly vertical → let the page scroll
          decided = true;                          // mostly horizontal → it's a drag
          try { ba.setPointerCapture(e.pointerId); } catch (err) {}
        }
        e.preventDefault();
        fromEvent(e);
      });
      ba.addEventListener('pointerup', function () { dragging = false; decided = false; });
      ba.addEventListener('pointercancel', function () { dragging = false; decided = false; });
      ba.addEventListener('keydown', function (e) {
        var cur = parseFloat(ba.getAttribute('aria-valuenow')) || 50;
        if (e.key === 'ArrowLeft') { setPos(cur - 4); e.preventDefault(); }
        if (e.key === 'ArrowRight') { setPos(cur + 4); e.preventDefault(); }
      });
      setPos(pos);

      /* ---- Auto-loop animation (pauses on hover) ---- */
      var autoReduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!autoReduce) {
        var DURATION = 2000; // ms per sweep (left→right or right→left)
        var paused = false;
        var rafId = null;
        var lastTs = null;
        var dir = 1; // 1 = moving right, -1 = moving left

        function tick(ts) {
          if (paused) { rafId = null; return; }
          if (lastTs == null) lastTs = ts;
          var delta = ts - lastTs;
          lastTs = ts;
          var step = (delta / DURATION) * 100 * dir;
          var next = pos + step;
          if (next >= 100) { next = 100; dir = -1; }
          else if (next <= 0) { next = 0; dir = 1; }
          setPos(next);
          rafId = requestAnimationFrame(tick);
        }
        function startAuto() {
          if (paused || rafId != null) return;
          lastTs = null;
          rafId = requestAnimationFrame(tick);
        }
        function stopAuto() {
          if (rafId != null) { cancelAnimationFrame(rafId); rafId = null; }
          lastTs = null;
        }

        ba.addEventListener('mouseenter', function () { paused = true; stopAuto(); });
        ba.addEventListener('mouseleave', function () { paused = false; startAuto(); });

        startAuto();
      }
    });

    /* ---- Scroll reveal ---- */
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var items = document.querySelectorAll('.crxlbd-reveal:not(.crxlbd-in)');
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('crxlbd-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('crxlbd-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-init in the theme editor when sections are added/reloaded */
  document.addEventListener('shopify:section:load', init);
})();
